import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Horarios from './Horarios';
import Home from './Home';
import Docentes from './Docentes';
import ReportePersonal from './ReportePersonal';
import Periodos from './Periodos';
import Configuracion from './Configuracion';
import CalendarioDocente from './CalendarioDocente';

import SubirValidar from './SubirValidar';

function App() {
  return (
    <>
      <nav style={{ padding: '12px 30px', background: '#0f172a', display: 'flex', gap: '20px', alignItems: 'center', overflowX: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <Link to="/" style={{ color: '#fff', textDecoration: 'none', fontWeight: '700', fontSize: '1rem', marginRight: '10px' }}>🏠 Panel</Link>
        <Link to="/docentes" style={{ color: '#cbd5e1', textDecoration: 'none', fontWeight: '500', fontSize: '0.9rem' }}>👨‍🏫 Docentes</Link>
        <Link to="/subir-validar" style={{ color: '#cbd5e1', textDecoration: 'none', fontWeight: '500', fontSize: '0.9rem' }}>📁 Subir</Link>
        <Link to="/configuracion" style={{ color: '#cbd5e1', textDecoration: 'none', fontWeight: '500', fontSize: '0.9rem' }}>⚙️</Link>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/subir-validar" element={<SubirValidar />} />
        <Route path="/configuracion" element={<Configuracion />} />
        <Route path="/docentes" element={<Docentes />} />
        <Route path="/periodos" element={<Periodos />} />
        <Route path="/horarios" element={<Horarios />} />
        <Route path="/reporte-personal/:id" element={<ReportePersonal />} />
        <Route path="/calendario/:id" element={<CalendarioDocente />} />
      </Routes>
    </>
  );
}

export default App;